import React, { useState, useEffect, useContext } from "react";
import Select from "react-select";
import { MDBInput } from "mdb-react-ui-kit";
import apiService from "../../Services/apiServices";
import { useToasts } from "react-toast-notifications";
import Search from "../../PageComponents/Search/Search";
import { confirmAlert } from "react-confirm-alert";
import helper from "../../Services/helper";
import globals from "../../Services/globals";
import UserPermissionContext from "../Context/UserPermissionContext";

function ReportsDashboard(props) {
  useEffect(() => {
    // getPermissions();
    document.getElementById('navi')?.classList.add("nav-mobile")
    getReports()
    return () => {
      document.getElementById('navi')?.classList.remove("nav-mobile")
    }
  }, [])
  const { addToast } = useToasts();
  const [reports, setReports] = useState();
  const { userPermission } = useContext(UserPermissionContext);

  const displayMsg = () => {
    addToast("së shpejti ky raport do të jet aktiv", { appearance: 'info', autoDismiss: true, });
  }

  const getReports = () => {
    apiService().query('getReports')
      .then((response) => {
        if (response.success) {
          const groupedItems = Object.values(
            response.data.reduce((acc, currentItem) => {
              const { id, reportsToken, path, repStyle } = currentItem;
              if (acc[id]) {
                acc[id].items.push({ id, reportsToken, path, repStyle, activeitem: false });
              } else {
                acc[id] = { id: currentItem.id, title: currentItem.grReportToken, color: currentItem.repStyle, items: [{ id, reportsToken, path, repStyle, activeitem: false }] };
              }
              return acc;
            }, {})
          );
          setReports(groupedItems)
        }
      })
  }
  // const getPermissions = () => {
  //   var params = `&username=${globals().getLogedInUser().data.username}`;
  //   apiService().query('getUserPermissions',params)
  //       .then((response) => {
  //        if(response.success){
  //          setUserPermissions(response.data)
  //        }
  //       })
  // }

  return (
    <div style={{ height: "85vh" }} className="container" >
      <div className="container-fluid mt-5">
        <div className="row">
          <div className="col-12 mb-4">
            <h4 className="m-0 mt-1 font-weight-bold text-center text-primary">{helper().translate("REPORTS")}</h4>
          </div>
          <hr style={{ width: "97%", margin: "auto", height: "2px", color: "black", backgroundColor: "black" }}></hr>
          <nav className="  header-tools"  >
            <div className=" col-lg-12 p-0" id="myHeader">
              <a href={'#/'} className="btn btn-success btn-icon-split btn-sm mt-2 mb-2 mr-2">
                <span className="icon text-white-40">
                  <i className="fas fa-arrow-left " />
                </span>
                <span className="text ">{helper().translate('BACK')}</span>
              </a>
            </div>
          </nav>
        </div>
        <div className="row mt-2">

          {reports?.map((rep, key) => {
            const hasViewPermission = userPermission?.find((f) => f.moduleName === rep.title)?.allowView;

            if (!hasViewPermission) return null;

            return (
              <a
                key={key}
                href={`#/reportsMap/${rep.id}`}
                className="text-decoration-none text-dark col-xl-4 col-md-6 mb-4 height100"
              >
                <div
                  style={{ borderBottom: `4px solid ${rep.color}` }}
                  className="card reportsHover shadow h-100 py-2"
                >
                  <div className="card-body">
                    <div className="row w-100 h-100 align-items-center justify-content-center">
                      <h5 className="text-xl text-center font-weight-bold text-dark mb-1">
                        {helper().translate(rep.title)}
                      </h5>
                    </div>
                  </div>
                </div>
              </a>
            );
          })}


        </div>
      </div>
    </div>
  )
}


export default ReportsDashboard;